<div>
  <small *ngIf="messageRestore" class="errorMessage">
    {{ messageRestore }}
    <ng-container *ngIf="showRestoreGuideLink">
      &nbsp;
      <a href="javascript:void(0)" (click)="downloadRestoreGuide()">
        {{ 'downloadRestoreGuide' | i18next }}
      </a>
    </ng-container>
  </small>
</div>
<div>
  <small *ngIf="messageLogin" class="errorMessage">
    {{ messageLogin }}
    <ng-container *ngIf="showGuideLink">
      &nbsp;
      <a href="javascript:void(0)" (click)="downloadLoginGuide()">
        {{ 'downloadLoginGuide' | i18next }}
      </a>
    </ng-container>
  </small>
</div>

<div>
  <small *ngIf="message" class="errorMessage">
    {{ message }}
  </small>
</div>
